// extracted by mini-css-extract-plugin
export var actionButton = "_d0-0";
export var attachmentLine = "_d0-1";
export var fileInput = "_d0-2";
export var fileUploadWrapper = "_d0-4";
export var footer = "_d0-3";
export var modalContent = "_d0-5";
export var paperclip = "_d0-6";
export var quillEditor = "_d0-7";